import {Component, forwardRef, Injector, Input, OnChanges, SimpleChanges} from "@angular/core";
import {ColumnComponent} from "../../../framework/entity/grid/column.component";
import {AbstractSingleSelectColumnComponent} from "../../../framework/entity/edit/edit-grid/columns/abstract-single-select-column.component";

@Component({
    selector: "wbo-size-group-single-select-column",
    templateUrl: "./size-group-single-select-column.component.html",
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => SizeGroupSingleSelectColumnComponent), multi: true}
    ]
})
export class SizeGroupSingleSelectColumnComponent extends AbstractSingleSelectColumnComponent implements OnChanges {
    @Input() sellableIdField: string;
    @Input() sizeGroupIdField: string;
    @Input() hideAddOption: boolean = false;

    constructor(injector: Injector) {
        super(injector);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.valueField = this.sizeGroupIdField || (this.field + ".id");
        this.labelField = this.field + ".name";
    }

    override editingFields(): string[] {
        return [this.sizeGroupIdField, this.field];
    }
}
